import React from 'react';
import PropTypes from 'prop-types';

const Star = ({ fill }) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 16 15"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.683 12.758 2.935 15l.61-5.328L0 5.729l5.125-1.05L7.683 0l2.557 4.678 5.125 1.051-3.544 3.943.61 5.328z"
      fill={fill}
      fillRule="evenodd"
    />
  </svg>
);

Star.propTypes = {
  fill: PropTypes.string,
};

Star.defaultProps = {
  fill: '#EAEAEA',
};

export default Star;
